import clevertap from "clevertap-web-sdk";

const eventPushFunction =({eventName, data})=> {
    clevertap.event.push(eventName, data);
}

export default eventPushFunction;